import { CREATETASKTEMPLATE_SUCCESS, CREATETASKTEMPLATE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const createTaskTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATETASKTEMPLATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CREATETASKTEMPLATE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createTaskTemplateReducer;
